import { BgImageContainer } from '@components/Layouts/BgImageContainer';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { ConfirmationSection } from '@components/TireOffer/ConfirmationSection';
import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard, NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useParams } from 'react-router-dom';
import { useIsPaymentSuccessful } from '../../../hooks/useIsPaymentSuccessful';
import { useTireQuoteSlug } from '../../../hooks/useTireQuoteSlug';
import { getErrorTextBasedOnErrorType } from '../../../utils/dinteroPayment';

export const TireOfferOrderConfirmed = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const slug = useTireQuoteSlug();

  const { error, isPaymentSuccessful } = useIsPaymentSuccessful();

  return (
    <BgImageContainer>
      <ContentWrapperCustomerApp hideBackButton className='flex min-h-[60vh] items-center justify-center'>
        {isPaymentSuccessful ? (
          <div className='flex flex-col gap-5 xxs:gap-6 lg:gap-16'>
            <ConfirmationSection slug={slug} />
          </div>
        ) : (
          <NoddiBasicCard className='flex w-full flex-col items-center gap-4 text-center'>
            <span className='text-2xl font-bold'>
              <Trans>Payment failed</Trans>
            </span>
            <span>{getErrorTextBasedOnErrorType(error)}</span>
            <NoddiLink className='w-full' to={customerRoutes.tireOfferConfirmation.getPath({ sessionId: sessionId! })}>
              <Trans>Try again</Trans>
            </NoddiLink>
          </NoddiBasicCard>
        )}
      </ContentWrapperCustomerApp>
    </BgImageContainer>
  );
};
